(function($){
	'use strict';
	jQuery(document).ready(function($) {
        var json_collection = {};
		var json_vendor =null ;
		var json_product_type =null;
		var curent_select = '';
		$("#categories-search").on('change',function(){
			var $val =jQuery(this).find('option[value="'+jQuery(this).val()+'"]').data('type');
			curent_select = $val;
			jQuery("#search-type").val('product:'+$val);
			if('product_type' == $val ){$val = 'types'}else{$val = 'vendors'}
			jQuery.get('/collections/'+$val,{q:jQuery(this).val(),view:'ajax'},function(response){
				response =  jQuery.parseJSON(response);
				if('types' == $val ){json_product_type = response;   }else{json_vendor = response; }
			});
		});
		window.setTimeout(function(){
			jQuery.ajax({
				url: '/collections/all',
				type: 'GET',
				data: {view: 'ajax'},
				success:function(response){
					json_collection =  jQuery.parseJSON(response);
				}
			});
		},3000);
		//Ai  lam template thi html config o function search
		function search_html(data){
			var $html = '<div class="col-md-3"><div class="images"><img src="'+data.images[0]+'" width="60" height="60"/></div> </div>';
			$html  = $html + '<div class="col-md-9 infor"> <a href="/products/'+data.handle+'"> <h4> '+data.title+'  </h4> </a> <p> Price <strong >'+data.price+'</strong> </p></div>';
			$html = '<div class="row"><div class="search_item"> '+$html+'</div> </div>';
			$("#search-results").append($html);
		}
      	console.log(json_collection);
		var limit_search = 5;
		var $current_search = null;
		jQuery("#ws").keyup(function(event) {
			event.preventDefault();
			clearTimeout($current_search);
			jQuery("#search-results").empty();
			var $val  = $(this).val();
			var check = 0;
			if($val.trim() == '') {return false;}
			$current_search = setTimeout(function(){
				var data_search = {};
				if( 'vendor' == curent_select ){
					data_search = json_vendor;
				}else if( 'product_type' == curent_select ){
					data_search = json_product_type;
				}else{
					data_search = json_collection;
				}
				var check_empty = true;
				$.grep(data_search, function($this,index){
					var matcher = new RegExp( $.ui.autocomplete.escapeRegex($val), "i" );
					if( matcher.test($this.title)){
						search_html($this);
						check_empty = false;
					}
				});
				if(check_empty){
					jQuery("#search-results").html('<div class="row"> <p> No results </p> </div>');
				}
			},1000);
		});

	});
})(jQuery);
